import Pet from './models';

export const getGender = (gender?: Pet.Gender) => {
  if (typeof gender === 'number') {
    return Pet.Gender[gender];
  }

  return '-';
};
